import { useQuery } from "@tanstack/react-query";
import { extractQueryState } from "../../helpers/extract-query-state";
import { getPartialCmaPresentationApiClient } from "../../apis/comps/presentation-api-client/api-client-factory";
import { PresentationView } from "@cma/presentation-generation-logic";
import { PresentationApiError } from "../../apis/comps/presentation-api-client/http-api-client";

const GET_CMA_PRESENTATION_QUERY_KEY = "get-cma-presentation-view";

export const buildGetCmaPresentationViewQueryKey = (cmaId: string) => {
  return [GET_CMA_PRESENTATION_QUERY_KEY, cmaId];
};

export function useGetCmaPresentationView(props: {
  cmaId: string;
  onSuccess?: (data: PresentationView) => void;
}) {
  const { cmaId, onSuccess } = props;
  const api = getPartialCmaPresentationApiClient();

  const query = useQuery<PresentationView, PresentationApiError>({
    queryKey: buildGetCmaPresentationViewQueryKey(cmaId),
    queryFn: async () => {
      const response = await api.getPresentationView(cmaId);
      if (onSuccess) {
        onSuccess(response);
      }
      return response;
    },
    retry: 1,
    retryDelay: 2000,
    enabled: !!cmaId,
  });

  return extractQueryState(query);
}
